import FileResolvedValuesList from './FileResolvedValuesList';
import FileValuesUnresolvedList from './FileUnresolvedValuesList';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FileValues = ({
  fileReferences,
  missingReferences,
  isEditDisabled,
  uploadsInProgress,
  onFileAction,
  status
}) => {
  /* TODO: Handle large lists in input - https://git.hubteam.com/HubSpot/PropertiesFrontendTeam/issues/1534*/
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [fileReferences && fileReferences.length > 0 && /*#__PURE__*/_jsx(FileResolvedValuesList, {
      fileReferences: fileReferences,
      isEditDisabled: isEditDisabled,
      uploadsInProgress: uploadsInProgress,
      onFileAction: onFileAction
    }), missingReferences.length > 0 && /*#__PURE__*/_jsx(FileValuesUnresolvedList, {
      missingFileReferences: missingReferences,
      isEditDisabled: isEditDisabled,
      showRemoveAction: true,
      onFileAction: onFileAction,
      status: status
    })]
  });
};
export default FileValues;